/**
 * Create a Discover Pakistan point (attraction / place).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from '../../components/layout/PageLayout';
import PointForm from '../../components/points/PointForm';

const PointCreatePage = () => {
  const navigate = useNavigate();

  return (
    <PageLayout title="Submit a Point">
      <div className="max-w-2xl mx-auto px-4 py-6">
        <button
          type="button"
          onClick={() => navigate('/points')}
          className="text-sm text-gray-600 hover:text-gray-900 mb-4"
        >
          ← Back to Points
        </button>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Submit a Point</h1>
        <p className="text-sm text-gray-600 mb-6">
          Share a tourist spot or attraction. For hotels, use{' '}
          <button
            type="button"
            onClick={() => navigate('/hotels/create')}
            className="text-emerald-700 font-medium hover:underline"
          >
            List a Hotel
          </button>
          .
        </p>
        <PointForm mode="create" />
      </div>
    </PageLayout>
  );
};

export default PointCreatePage;
